
import { Box, Button } from '@mui/material'
import { SummarizeRounded } from 'resource/muiImport'
import { BoxFC, BoxFR } from 'components/BoxCustom'
import ComboBox from 'components/ComboBox'
import DataGridCellExpand from 'components/DataGridCellExpand/DataGridCellExpand'
import React, { useCallback, useState, useContext, useEffect } from 'react'
import { GlobalStateContext } from 'contexts/GlobalStateContext'
import SearchButton from 'components/buttons/SearchButton'
import ClearButton from 'components/buttons/ClearButton'
import { initFilterData, clearFilterData } from './initData'
import { addIdForDataGrid } from 'utils'
import { oilChangeApiNm } from './constant'
import AddButton from 'components/buttons/AddButton'
import OilChangeDialog from './OilChangeDialog'
import OilChangeSummaryDialog from './OilChangeSummaryDialog'
import { oilChangeColumns } from './columns'
import DateTimeSelect from 'components/DateTimeSelect/DateTimeSelect'

const sparePartApiNm = { getSparePart: "/spare-part/getSparePart" }

let selectedId = null
let lastFilter = null

const OilChangeManagement = () => {
  const { ax, msData } = useContext(GlobalStateContext)
  const [dataTable, setDataTable] = useState([])
  const [dialogOpen, setDialogOpen] = useState(false)
  const [filterData, setFilterData] = useState({ ...initFilterData })
  const [sparePartCombo, setSparePartCombo] = useState([])
  const [summaryDialogOpen, setSummaryDialogOpen] = useState(false)

  const getData = useCallback((filter) => {
    ax.post(oilChangeApiNm.getOilChange, filter).then(value => {
      if (value.data) {
        setDataTable(addIdForDataGrid(value.data, 'SpTrnsId'))
        lastFilter = filter
      }
    })
  }, [ax])

  const handleCellClick = useCallback((params) => {
    if (params.field === 'ShowDetail') {
      selectedId = params.id
      setDialogOpen(true)
    }
  }, [])

  const handleRowDoubleClick = useCallback((params) => {
    selectedId = params.id
    setDialogOpen(true)
  }, [])

  const onFinish = useCallback(() => {
    getData(lastFilter)
  }, [getData])

  const handleAdd = useCallback(() => {
    selectedId = null
    setDialogOpen(true)
  }, [])

  useEffect(() => {
    getData({ ...initFilterData })
    ax.post(sparePartApiNm.getSparePart, { IsActv: 1, SpTypId: 1 }).then(value => {
      if (value.data) {
        setSparePartCombo(value.data.map(item => ({ id: item.SpId, label: `${item.SpCd ? item.SpCd + ' - ' : ''}${item.SpNm}`, UntPr: item.UntPr })))
      }
    })
  }, [getData, ax])

  return (
    <BoxFC height='100%'>
      <BoxFR>
        <AddButton onClick={handleAdd}>เพิ่มรายการ</AddButton>
        <Button variant="contained" color="secondary" startIcon={<SummarizeRounded />}
          onClick={() => setSummaryDialogOpen(true)}>
          สรุปรายการเปลี่ยนถ่ายน้ำมัน
        </Button>
        <Box flex={1} />
        <ComboBox
          options={msData.truckCombo || []}
          label="รถ"
          selectedId={filterData.TukId}
          setSelectedId={(id) => setFilterData(o => ({ ...o, TukId: id }))}
          sx={{ width: 150 }}
        />
        <ComboBox
          options={sparePartCombo}
          label="น้ำมัน"
          selectedId={filterData.SpId}
          setSelectedId={(id) => setFilterData(o => ({ ...o, SpId: id }))}
          sx={{ width: 180 }}
        />
        <DateTimeSelect
          label="วันที่เปลี่ยน"
          start={filterData.ChgDteSt}
          end={filterData.ChgDteEn}
          setSelectDate={(st, en) => setFilterData(o => ({ ...o, ChgDteSt: st, ChgDteEn: en }))}
          getData={() => getData(filterData)}
          initRadioValue="RANGE"
        />
        <SearchButton onClick={() => getData(filterData)} />
        <ClearButton onClick={() => setFilterData({ ...clearFilterData })} />
      </BoxFR>
      <Box height='100%'>
        <DataGridCellExpand
          hideFooter
          rows={dataTable}
          columns={oilChangeColumns}
          onRowDoubleClick={handleRowDoubleClick}
          onCellClick={handleCellClick}
        />
      </Box>
      <OilChangeDialog
        selectedId={selectedId}
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        onFinish={onFinish}
        sparePartCombo={sparePartCombo}
      />
      <OilChangeSummaryDialog
        dialogOpen={summaryDialogOpen}
        setDialogOpen={setSummaryDialogOpen}
      />
    </BoxFC>
  )
}

export default OilChangeManagement
